import { ApiResourceMethod } from '@/api/api-requests-factory';
import { BaseResponse } from '@/api/api-requests-factory/models/response.model';
import { RequestListPayload } from '@/models/common/request-list-payload.model';
import { clearObj } from '@marfa/bo-utils';
import { ResponseWithHeaders } from '@/models/common/response-with-header.model';
import { DocumentListItemResponse } from '@/models/documents/document-list.model';
import { DocumentListFilter } from '@/models/documents/document-list-filter.model';

export class GetDocumentListRequest extends ApiResourceMethod<ResponseWithHeaders<DocumentListItemResponse[]>> {
  public perform(
    whitelabelSlug: string,
    payload: RequestListPayload<DocumentListFilter>,
  ): Promise<ResponseWithHeaders<DocumentListItemResponse[]>> {
    return this.performer.requestWithMapper(
      {
        url: `${whitelabelSlug}/v2/dashboard/file`,
        params: clearObj(payload),
      },
      ({ data, headers }: BaseResponse<DocumentListItemResponse[]>):
      ResponseWithHeaders<DocumentListItemResponse[]> => ({
        data,
        headers,
      }),
    );
  }
}
